<template>
  <div class="reports__tab-special-instructions">
    <grid ref="grid" :config="gridConfig" class="no-grid-border"/>
    <modal-new :config="{ id: gridConfig.id, api: 'CompanyRemarks/Get/' }" :companyID="filterID" :editorID="editorID"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'
import mixin from './../mixin.js'
export default {
  name: 'TabQualityScore',
  mixins: [mixin],
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './ModalNew.vue')
  },
  props: {
    editorID: { required: true }
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    loadData (grid) {
      let filters = `companyID==${this.filterID}`
      grid.setFilters(filters)
      grid.loadData()
    }
  }
}
</script>
<style lang="stylus">
  .content{
    .reports__tab-special-instructions{
      .grid-head{
        justify-content: flex-end;
      }
    }
  }
</style>
